<template>
    <form class="el-form"
          :class="[
            labelPosition ? 'el-form-label-' + labelPosition : '',
            {'el-form-inline':inline}
          ]"
          @keyup.enter="handleEnter">
        <slot></slot>
    </form>
</template>
<script>
    export default{
        name:'ElForm',
        componentName:'form',
        props:{
            model:Object,
            rules:Object,
            labelPosition:String,
            labelWidth:String,
            labelSuffix:{
                type:String,
                default:''
            },
            inline:Boolean
        },
        watch:{
            rules(){
                this.validate();
            }
        },
        data(){
            return {
                fields:[]
            }
        },
        created(){
            this.$on('el.form.addField',(field) => {
                if(field){
                    this.fields.push(field);
                }

            });

            this.$on('el.form.removeField',(field)=>{
               if(field.prop){
                   this.fields.splice(this.fields.indexOf(field),1);
               }
            });
        },
        methods:{
            handleEnter(event){
                this.$emit('enter',event);
            },
            resetFields(){
                this.fields.forEach(field => {
                   field.resetField();
                });
            },
            validate(callback){
                let valid = true;
                this.fields.forEach((field,index) => {
                   field.validate('', errors => {
                       if(errors){
                           valid = false;
                       }
                       if(typeof callback === 'function' && index === this.fields.length - 1){
                           callback(valid);
                       }
                    });
                });
            },
            validateField(prop,cb){
                var field = this.fields.filter(field => field.prop === prop)[0];
                if(!field){
                    throw new Error('must call validateField with valid prop string!');
                }
                field.validate('',cb);
            }
        }
    }
</script>


// WEBPACK FOOTER //
// form.vue?0ed981dc